export const areaToPrefTable = [
  {
    name: '北海道',
    key: 'hokkaido',
    pref_list: [
      { name: '道央', key: 'douou' },
      { name: '道南', key: 'dounan' },
      { name: '道北', key: 'douhoku' },
      { name: '道東', key: 'doutou' }
    ]
  },
  {
    name: '東北',
    key: 'tohoku',
    pref_list: [
      { name: '青森', key: 'aomori' },
      { name: '岩手', key: 'iwate' },
      { name: '秋田', key: 'akita' },
      { name: '宮城', key: 'miyagi' },
      { name: '山形', key: 'yamagata' },
      { name: '福島', key: 'fukushima' }
    ]
  },
  {
    name: '関東',
    key: 'kanto',
    pref_list: [
      { name: '東京', key: 'tokyo' },
      { name: '神奈川', key: 'kanagawa' },
      { name: '埼玉', key: 'saitama' },
      { name: '千葉', key: 'chiba' },
      { name: '茨城', key: 'ibaraki' },
      { name: '栃木', key: 'tochigi' },
      { name: '群馬', key: 'gunma' }
    ]
  },
  {
    name: '中部',
    key: 'chubu',
    pref_list: [
      { name: '静岡', key: 'shizuoka' },
      { name: '愛知', key: 'aichi' },
      { name: '岐阜', key: 'gifu' },
      { name: '山梨', key: 'yamanashi' },
      { name: '長野', key: 'nagano' },
      { name: '新潟', key: 'niigata' },
      { name: '富山', key: 'toyama' },
      { name: '石川', key: 'ishikawa' },
      { name: '福井', key: 'fukui' }
    ]
  },
  {
    name: '近畿',
    key: 'kinki',
    pref_list: [
      { name: '大阪', key: 'osaka' },
      { name: '兵庫', key: 'hyogo' },
      { name: '京都', key: 'kyoto' },
      { name: '滋賀', key: 'shiga' },
      { name: '奈良', key: 'nara' },
      { name: '和歌山', key: 'wakayama' },
      { name: '三重', key: 'mie' }
    ]
  },
  {
    name: '中国',
    key: 'chugoku',
    pref_list: [
      { name: '広島', key: 'hiroshima' },
      { name: '岡山', key: 'okayama' },
      { name: '山口', key: 'yamaguchi' },
      { name: '島根', key: 'shimane' },
      { name: '鳥取', key: 'tottori' }
    ]
  },
  {
    name: '四国',
    key: 'shikoku',
    pref_list: [
      { name: '香川', key: 'kagawa' },
      { name: '徳島', key: 'tokushima' },
      { name: '愛媛', key: 'ehime' },
      { name: '高知', key: 'kouchi' }
    ]
  },
  {
    name: '九州',
    key: 'kyushu',
    pref_list: [
      { name: '福岡', key: 'fukuoka' },
      { name: '佐賀', key: 'saga' },
      { name: '長崎', key: 'nagasaki' },
      { name: '大分', key: 'oita' },
      { name: '熊本', key: 'kumamoto' },
      { name: '宮崎', key: 'miyazaki' },
      { name: '鹿児島', key: 'kagoshima' }
    ]
  },
  {
    name: '沖縄',
    key: 'okinawa',
    pref_list: []
  }
]

export const areaToLatLonTable = {
  JAPAN: { lat: 38.6450000, lon: 137.467052, zoom: 4 },
  HOKKAIDO: { lat: 43.3147805153402, lon: 142.492769253488, zoom: 6 },
  TOHOKU: { lat: 39.1704307366595, lon: 140.357589561569, zoom: 6.4 },
  KANTO: { lat: 34.7820758815955, lon: 138.998842103662, zoom: 8 },
  KANTO2: { lat: 35.93600178659, lon: 139.442822706001, zoom: 7.3 },
  CHUBU: { lat: 36.1108863965018, lon: 137.71107138275, zoom: 7 },
  CHUBU2: { lat: 35.0600465128082, lon: 136.664264083626, zoom: 9 },
  KINKI: { lat: 34.5974152537683, lon: 135.709004164408, zoom: 7.2 },
  CHUGOKU: { lat: 34.9560420949593, lon: 132.574274898937, zoom: 7 },
  SHIKOKU: { lat: 33.5725208229352, lon: 133.38189071892, zoom: 7.4 },
  KYUSHU: { lat: 32.5369346457068, lon: 130.550196055694, zoom: 7 },
  OKINAWA_N: { lat: 26.7711010900717, lon: 127.711575038793, zoom: 9 },
  OKINAWA_S: { lat: 25.0107245999585, lon: 124.319607399439, zoom: 9 },
  OKINAWA: { lat: 26.105806324426, lon: 126.253184202583, zoom: 6 },
  AKITA: { lat: 39.673113154156, lon: 140.424727730177, zoom: 8 },
  HONTOU: { lat: 26.498442584987, lon: 127.70593199713, zoom: 9 },
  TOKYO: { lat: 35.7344638104283, lon: 139.462000859646, zoom: 9 },
  AOMORI: { lat: 40.8110612290248, lon: 140.769586064051, zoom: 8 },
  TOKUSHIMA: { lat: 33.914124141527, lon: 134.237709983014, zoom: 9 },
  FUKUOKA: { lat: 33.6929932568361, lon: 130.589180583845, zoom: 8.5 },
  AICHI: { lat: 34.9761776192127, lon: 137.24146046453, zoom: 8.5 },
  AMAMI: { lat: 28.238791651684, lon: 129.169372205673, zoom: 9 },
  NIIGATA: { lat: 37.6074781364233, lon: 138.711600877861, zoom: 8 },
  DOUHOKU: { lat: 44.1766144655253, lon: 142.074375056132, zoom: 8 },
  YAMAGATA: { lat: 38.434844543198, lon: 139.956629125333, zoom: 8 },
  SHIZUOKA: { lat: 35.0387419617787, lon: 138.316949122248, zoom: 8 },
  TOYAMA: { lat: 36.648910148336, lon: 137.275348961663, zoom: 9 },
  NAGASAKI: { lat: 33.5067670709987, lon: 129.541889801944, zoom: 8 },
  YAMANASHI: { lat: 35.581437822056, lon: 138.639016782313, zoom: 9 },
  KAGOSHIMA: { lat: 31.49094189474, lon: 130.550801257681, zoom: 8.2 },
  SAGA: { lat: 33.2881051550938, lon: 130.11985927014, zoom: 9 },
  SAKISHIMA: { lat: 25.3647537745417, lon: 124.971229270072, zoom: 9 },
  SAITAMA: { lat: 35.941656511442, lon: 139.306068156507, zoom: 8.6 },
  MIE: { lat: 34.4657485782978, lon: 136.293857178562, zoom: 8.4 },
  IBARAKI: { lat: 36.3117410278795, lon: 140.310456580739, zoom: 8.4 },
  KAGAWA: { lat: 34.2315893051082, lon: 133.98971080838, zoom: 9 },
  TANEGASHIMA: { lat: 30.7354865623448, lon: 130.169040273951, zoom: 9 },
  KYOTO: { lat: 35.1944848958208, lon: 135.433821596397, zoom: 8.5 },
  KUMAMOTO: { lat: 32.5934511566785, lon: 130.627404732995, zoom: 8.6 },
  TSUSHIMA: { lat: 34.236046246765, lon: 129.307160448438, zoom: 9 },
  MIYAGI: { lat: 38.4181431727088, lon: 140.966669736523, zoom: 8 },
  EHIME: { lat: 33.5812385380167, lon: 132.882224714321, zoom: 8.4 },
  HYOGO: { lat: 34.9022546689915, lon: 134.771237390772, zoom: 8.1 },
  DOUTOU: { lat: 43.2719640734857, lon: 144.317562193347, zoom: 7 },
  DOUOU: { lat: 43.162028391494, lon: 141.104109045381, zoom: 8 },
  NARA: { lat: 34.3127770014575, lon: 135.840452961458, zoom: 8.8 },
  NAGANO: { lat: 36.0849750552773, lon: 138.02821901125, zoom: 8 },
  OITA: { lat: 33.1876828290325, lon: 131.415047457835, zoom: 8.8 },
  ISHIKAWA: { lat: 36.7805877427748, lon: 136.753775535887, zoom: 8.2 },
  MIYAZAKI: { lat: 32.0770036827472, lon: 131.236545527876, zoom: 8.2 },
  GUNMA: { lat: 36.48010379382, lon: 139.003400288112, zoom: 8.6 },
  KANAGAWA: { lat: 35.3563262216678, lon: 139.440604757217, zoom: 9 },
  WAKAYAMA: { lat: 33.9261275773755, lon: 135.486487819343, zoom: 8.8 },
  SHIGA: { lat: 35.2365840809182, lon: 136.135462157876, zoom: 9 },
  FUKUI: { lat: 35.8082890025273, lon: 136.108300855309, zoom: 8.5 },
  IZU: { lat: 31.1284839165332, lon: 140.031836761129, zoom: 8 },
  FUKUSHIMA: { lat: 37.4108893086075, lon: 140.109982140618, zoom: 8 },
  YAMAGUCHI: { lat: 34.2439002085126, lon: 131.598268553814, zoom: 8.6 },
  OKAYAMA: { lat: 34.7419664374803, lon: 133.863987702736, zoom: 8.4 },
  GIFU: { lat: 35.7803043337995, lon: 137.010560630143, zoom: 8.2 },
  HIROSHIMA: { lat: 34.4770873764437, lon: 132.774094943809, zoom: 8.4 },
  KOUCHI: { lat: 33.3275195941585, lon: 133.353411403605, zoom: 8.4 },
  OSAKA: { lat: 34.640350345675, lon: 135.355252904013, zoom: 9 },
  IWATE: { lat: 39.5821406771585, lon: 141.40440855586, zoom: 8 },
  SHIMANE: { lat: 35.2849919197658, lon: 132.44636663617, zoom: 8.2 },
  CHIBA: { lat: 35.4665350799713, lon: 140.198980407397, zoom: 8.4 },
  DOUNAN: { lat: 42.4382391516222, lon: 141.339522705042, zoom: 8 },
  TOTTORI: { lat: 35.3891494011555, lon: 133.797202911825, zoom: 8.6 },
  ASIA_E: { lat: 22.4905654853067, lon: 135.882711918456, zoom: 9 },
  TOCHIGI: { lat: 36.6612227276572, lon: 139.795062721959, zoom: 8.6 }
}
